module.exports = "https://static-production.npmjs.com/b0f1a8318363185cc2ea6a40ac23eeb2.png";